export const patientAddressData = [
  {
    address_line_1: '',
    zip_code: '',
    address_line_2: '',
    city: '',
    po_box: false,
    patient_address_type: undefined,
    state: undefined,

    country: {
      id: 1,
    },
  },
]
export const patientContactData = [
  {
    voicemail_allowed: false,
    mobile_device: false,
    texting_allowed: false,
    phone_number: '',
    phone_number_extension: '',
    phone_priority: undefined,
    phone_type: undefined,
  },
]
export const providerContactData = [
  {
    phone_number: '',
    phone_number_extension: '',
    phone_priority: undefined,
    phone_type: undefined,
  },
]
export const contactAddressData = [
  {
    address_line_1: '',
    zip_code: '',
    address_line_2: '',
    city: '',
    po_box: false,
    address_type: undefined,
    country: { id: 1 },
    state: undefined,
  },
]
